import { axiosInstance } from "./axiosInstance";

const cleanParams = (params = {}) =>
	Object.fromEntries(
		Object.entries(params).filter(
			([, value]) => value !== undefined && value !== null && value !== ""
		)
	);

const BASE = "/api/feature/class/schedule/private/session-progress";

export const SessionProgressService = {
	getAnalytics: async (params = {}) =>
		axiosInstance.get(`${BASE}/analytics`, {
			params: cleanParams(params),
		}),

	getSessions: async (params = {}) =>
		axiosInstance.get(`${BASE}/sessions`, {
			params: cleanParams(params),
		}),

	getSessionDetail: async (id) =>
		axiosInstance.get(`${BASE}/sessions/${id}`),
};
